<template>
  <div class="dropdown">
    <a
        ref="triggerRef"
        href="#"
        class="icon"
        data-bs-toggle="dropdown"
    >
      <i class="bi bi-three-dots"></i>
    </a>

    <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow" :class="classList">
      <slot />
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { Dropdown } from 'bootstrap';

const props = defineProps({
  classList: String
});

const triggerRef = ref(null);
let dropdown = null;

onMounted(() => {
  dropdown = new Dropdown(triggerRef.value);
});

onUnmounted(() => {
  dropdown?.dispose();
});
</script>
